// components
import { styled } from '@mui/material';
import { IconContainer } from '../Header/Header.styles';

export const StyledQualificationIconContainer = styled(IconContainer)(
  ({ theme }) => ({
    marginRight: theme.spacing(1)
  })
);
